
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";

interface EmailConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
}

export const EmailConfirmationDialog = ({ 
  isOpen, 
  onClose,
  email 
}: EmailConfirmationDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md bg-gray-800 text-white border border-gray-700">
        <DialogHeader>
          <DialogTitle className="text-center text-xl flex items-center justify-center gap-2">
            <Mail className="h-5 w-5 text-blue-400" />
            Confirm Your Email
          </DialogTitle>
          <DialogDescription className="text-center text-gray-300">
            We've sent a confirmation email to:
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex flex-col items-center space-y-4 py-4">
          <div className="px-3 py-2 bg-gray-700/50 rounded-lg w-full text-center">
            <p className="text-blue-300 font-medium break-all">{email}</p>
          </div>
          
          <div className="text-sm text-gray-300 text-center space-y-2">
            <p>Please check your inbox and click the confirmation link to activate your account.</p>
            <p>If you don't see the email, please check your spam folder.</p>
          </div>
        </div>
        
        <div className="flex justify-center">
          <Button 
            onClick={onClose}
            className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700"
          >
            I'll check my email
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
